module.exports = __webpack_public_path__ + "static/media/hail-icon.b18d02ae.svg";